import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import CRUDLayout, {CRUDMapStateToPropsPropTypes, CRUDMapDispatchToProps, CRUDMapDispatchToPropsPropTypes, CRUDMapStateToProps} from "CRUDLayout";
import productTypesActions from "../../actions/productTypes";
import TableWithModalsMixin from "../../components/TableWithModalsMixin";
import ProdutTypeModal from "./ProductTypeModal";
import columnsGenerator from "./tableColumns";


export class ProdutTypeListComponent extends TableWithModalsMixin {
    render = () => (
      <CRUDLayout
        {...this.props}
        title='Product Types'
        entityName='productTypes'
        columnsGenerator={columnsGenerator}
        addModalComponent={ProdutTypeModal}
        getItem={this.getItem}
        onSave={this.saveItem}
        handleDragEnd={this.handleDragEnd}
      />
    );
}

ProdutTypeListComponent.propTypes = {
  ...CRUDMapStateToPropsPropTypes,
  ...CRUDMapDispatchToPropsPropTypes,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      code: PropTypes.string,
      name: PropTypes.string,
      isDeprecated: PropTypes.bool
    })
  ).isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.number,
    code: PropTypes.string,
    name: PropTypes.string,
    isDeprecated: PropTypes.bool
  }),
};

export const mapStateToProps = state => {
    return (
        CRUDMapStateToProps(
            state,
            'productTypes',
            "exercise.change_producttype",
            "exercise.add_producttype",
        )
    )
}

export const mapDispatchToProps = dispatch => (
  CRUDMapDispatchToProps(dispatch, productTypesActions, 'productTypes')
);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProdutTypeListComponent)
);
